import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'tenants',
    path: '/tenants',
    component: () => LazyLoadView(import(/* webpackChunkName: "tenants" */ '@/views/Tenant/Component.vue')),
    beforeEnter: isAuthenticated,
  },
]
